import styled from 'styled-components'

import Input from '../../../common/components/Input'

export const ButtonContainer = styled.div`
    @media (min-width: ${({ theme }) => theme.breakPoints.sm}) {
        transform: translateX(-42px);
    }
`

export const StyledInput = styled(Input)`
    padding: 1.5rem 4.375rem 1.5rem 3.125rem;

    @media (max-width: ${({ theme }) => theme.breakPoints.sm}) {
        padding-left: 3.125rem;
        padding-right: 1.5rem;
    }
`
